<template>
    <div @click="loginRedirect" :class="classes">
        <!-- <table>
            <tr>
                <td class= "login-text"> -->
                    <span><slot></slot></span>
                <!-- </td>
                <td> -->
                    <span class="helper"></span><img :src="require(`../assets/twitch-logo.svg`)" class="login-img" />
                <!-- </td>
            </tr>
        </table> -->
    </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'login-btn',
  props: {
    buttonClass: {
      type: String,
      default: 'login-btn'
    },
    buttonSelectedClass: {
      type: String,
      default: 'login-btn-selected'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    loginUrl () {
      return Vue.config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/login?path=' + encodeURIComponent(this.$route.path)
    },
    classes () {
      return {
        [this.buttonClass]: true,
        [this.buttonSelectedClass]: this.selected
      }
    }
  },
  methods: {
    loginRedirect () {
      window.location = this.loginUrl
    }
  }
}
</script>

<style scoped>
    .login-btn{
    background-color: #5A3E85;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(126, 85, 187) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
    }
    .login-btn:hover{
    background-color: rgb(126, 85, 187);
    }
    .login-text{
    font-size : 18px;
    padding-right: 5px;
    }
    .login-img{
    width: 25px;
    vertical-align: middle;
    }
    .helper {
      display: inline-block;
    height: 100%;
    vertical-align: middle;
    }
    .btn-enabled{
        display: inline-block;
        border-top: 4px #b62626 solid;
        padding: 5px;
        border-radius: 4px;
        box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
        transition: background-color 0.2s , border-color 0.2s;
        margin: 5px;
        min-width: 50px;
        user-select: none;
        cursor: pointer;
        color:white;
    }
    .btn-enabled:hover{
        background-color: #b62626;
        border-top: 4px rgb(255, 0, 0) solid;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login-Btn.vue